import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICON } from '@core/util/icon';
import {
	StewartModalComponent,
	StewartModalData,
} from '../../stewart-modal/stewart-modal.component';
import { TestHooks } from './declined.hooks';

@Component({
	selector: 'app-stewart-declined',
	templateUrl: './declined.component.html',
	styleUrls: ['./declined.component.scss'],
	standalone: false,
})
export class StewartDeclinedComponent {
	testHooks = TestHooks;
	public ICON = ICON;

	constructor(private dialog: MatDialog) {}

	openPortal() {
		const data: StewartModalData = {
			submitNewOrder: true,
		};

		this.dialog.open(StewartModalComponent, { data });
	}
}
